import { css } from '@emotion/core'
import styled, { Theme } from '@themes/theme'

export const PopupTxt = styled.p`
  color: ${props => props.theme.color.modalTxt};
  float: right;
  /* font-size: ${props => props.theme.font.large}; */
  margin-top: 2px;
  span {
    float: none;
    width: auto;
    svg {
      position: relative;
      top: 2px;
      margin: 0 2px;
    }
  }
  &.text-center {
    float: none;
  }
`
export const PickPopupRowStyle = (theme: Theme) => css`
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  align-items: center;
  width: auto;
  text-align: left;
  margin: 6px 20px !important;
  padding: 5px 10px;
  border-radius: 20px;
  background-color: ${theme.color.modalSubBg2};
  .pick-popup-price-txt {
    flex: 1;
    max-width: 95px;
    color: ${theme.color.modalSubTxt};
    text-align: right;
  }
  .pick-popup-price-num {
    flex: 2.5;
    text-align: right;
    &--type {
      margin-left: 4px;
      font-size: ${theme.font.title};
      color: ${theme.color.modalTxt};
      svg {
        position: relative;
        top: 4px;
        width: 20px;
      }
    }
  }

`
export const Num = styled.span`
  width: 100%;
  display: inline-block;
  &.pick-popup {
    width: 85%;
    text-align: right;
    font-size: ${props => props.theme.font.title};
    color: ${props => props.theme.color.modalTxt};
    margin-top: 2px;
  }
`
// export const GmoneyStyle = styled.span`
//   position: relative;
//   float: right;
//   top: 1px;
//   svg {
//     position: absolute;
//     right: 0;
//     width: 20px;
//   }
// `
